
import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Calendar } from "lucide-react";

interface DaysSelectorProps {
  selectedDays: number;
  onDaysChange: (days: number) => void;
}

const DaysSelector: React.FC<DaysSelectorProps> = ({ 
  selectedDays, 
  onDaysChange 
}) => {
  const options = [5, 6, 7, 8, 9, 10];

  return (
    <div className="flex flex-col items-center gap-2">
      <label className="text-sm font-medium flex items-center gap-1 text-gray-700 dark:text-gray-300">
        <Calendar className="w-4 h-4" />
        Dias de Resultados
      </label>
      <Select 
        value={selectedDays.toString()} 
        onValueChange={(value) => onDaysChange(parseInt(value))}
      >
        <SelectTrigger className="w-[140px] bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600">
          <SelectValue placeholder="Selecione" />
        </SelectTrigger>
        <SelectContent>
          {options.map(days => (
            <SelectItem 
              key={days} 
              value={days.toString()}
            >
              {days} dias
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default DaysSelector;
